export const publicationTabs = [
  {
    id: 1,
    content: 'All Publications',
  },
  {
    id: 2,
    content: 'Major Publications',
  },
];

export const perPageFilterDataDesktop = [
  { id: 1, label: '15', value: '15' },
  { id: 2, label: '30', value: '30' },
  { id: 3, label: '60', value: '60' },
  { id: 4, label: '120', value: '120' },
];

export const perPageFilterDataTablet = [
  { id: 1, label: '10', value: '10' },
  { id: 2, label: '20', value: '20' },
  { id: 3, label: '50', value: '50' },
  { id: 4, label: '100', value: '100' },
];

export const perPageFilterDataMobile = [
  { id: 1, label: '5', value: '5' },
  { id: 2, label: '10', value: '10' },
  { id: 3, label: '20', value: '20' },
  { id: 4, label: '50', value: '50' },
];
export const AlphabetHeaders = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
];
